import { render, staticRenderFns } from "./ReadArticle.vue?vue&type=template&id=bc464960"
import script from "./ReadArticle.vue?vue&type=script&lang=js"
export * from "./ReadArticle.vue?vue&type=script&lang=js"
import style0 from "./ReadArticle.vue?vue&type=style&index=0&id=bc464960&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports